export default function (v: string | null): string {
  if (!v) return "";
  const parts = v.split(" ");
  return parts[0].split("-").reverse().join("-") + " " + parts[1];
}
